var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 5.95423C14.6668 5.55035 14.6668 5.34841 14.587 5.2549C14.5177 5.17376 14.4137 5.13071 14.3073 5.13908C14.1847 5.14873 14.042 5.29152 13.7564 5.5771L11.3335 7.99998L13.7564 10.4229C14.042 10.7084 14.1847 10.8512 14.3073 10.8609C14.4137 10.8693 14.5177 10.8262 14.587 10.7451C14.6668 10.6515 14.6668 10.4496 14.6668 10.0457V5.95423Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 6.53331C1.3335 5.41321 1.3335 4.85316 1.55148 4.42533C1.74323 4.04901 2.04919 3.74305 2.42552 3.5513C2.85334 3.33331 3.41339 3.33331 4.5335 3.33331H8.1335C9.2536 3.33331 9.81365 3.33331 10.2415 3.5513C10.6178 3.74305 10.9238 4.04901 11.1155 4.42533C11.3335 4.85316 11.3335 5.41321 11.3335 6.53331V9.46665C11.3335 10.5868 11.3335 11.1468 11.1155 11.5746C10.9238 11.951 10.6178 12.2569 10.2415 12.4487C9.81365 12.6666 9.2536 12.6666 8.1335 12.6666H4.5335C3.41339 12.6666 2.85334 12.6666 2.42552 12.4487C2.04919 12.2569 1.74323 11.951 1.55148 11.5746C1.3335 11.1468 1.3335 10.5868 1.3335 9.46665V6.53331Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.189eec5490c1bf9f48cc20fc94d639bc.svg";
export { ForwardRef as ReactComponent };